<template>
  <div class="search-container">
    <el-checkbox :value="showOnlySelected" @input="handleChangeShowOnlySelected"
      >แสดงเฉพาะผู้ที่ถูกเลือก</el-checkbox
    >
    <div class="search input-group">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </div>
      <input
        type="text"
        class="form-control"
        v-model="searchText"
        @keyup.enter="enterSearch"
        :placeholder="$t('feature.attendance.search_placeholder')"
      />
    </div>
  </div>
</template>

<script>
import { Checkbox } from "element-ui";
export default {
  components: { "el-checkbox": Checkbox },
  props: ["showOnlySelected"],
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    enterSearch() {
      this.$emit("search", this.searchText);
    },
    handleChangeShowOnlySelected(value) {
      this.showOnlySelected = value;

      this.$emit("showOnlySelected", this.showOnlySelected);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;
  padding: 0;

  > .el-checkbox {
    margin-right: 10px;
    margin-bottom: 0;
  }

  > .search {
    padding: 0;
  }

  .input-group-text {
    border-top-left-radius: 10em;
    border-bottom-left-radius: 10em;
    background-color: $white;
  }

  .form-control {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    border-top-right-radius: 10em;
    border-bottom-right-radius: 10em;
    border-left: none;
    padding-left: 0;
    color: #4a4a4a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/attendance/search.vue